import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEllipsisVertical = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	color: "#50566E",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 11.875C11.5355 11.875 12.375 11.0355 12.375 10C12.375 8.96447 11.5355 8.125 10.5 8.125C9.46447 8.125 8.625 8.96447 8.625 10C8.625 11.0355 9.46447 11.875 10.5 11.875Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 18.125C11.5355 18.125 12.375 17.2855 12.375 16.25C12.375 15.2145 11.5355 14.375 10.5 14.375C9.46447 14.375 8.625 15.2145 8.625 16.25C8.625 17.2855 9.46447 18.125 10.5 18.125Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 5.625C11.5355 5.625 12.375 4.78553 12.375 3.75C12.375 2.71447 11.5355 1.875 10.5 1.875C9.46447 1.875 8.625 2.71447 8.625 3.75C8.625 4.78553 9.46447 5.625 10.5 5.625Z",
			fill: "currentColor"
		})
	]
});
export default SvgEllipsisVertical;
